// auth.js
export const LOGOUT = "LOGOUT";
export const SAVE_TOKEN = "SAVE_TOKEN";
export const SAVE_SUGAR_ACCESSTOKEN = "SAVE_SUGAR_ACCESSTOKEN";
export const SAVE_SUGAR_REFRESHTOKEN = "SAVE_SUGAR_REFRESHTOKEN";
export const SAVE_SUGAR_DOWNLOADTOKEN = "SAVE_SUGAR_DOWNLOADTOKEN";
export const FETCH_USER = "FETCH_USER";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";
export const UPDATE_USER = "UPDATE_USER";

export const SET_USER_ID = "SET_USER_ID";
export const SEARCH_USERS = "SEARCH_USERS";
export const DESELECT_USER = "DESELECT_USER";
export const SELECT_USER = "SELECT_USER";
export const SET_USER_COUNTRY = "SET_USER_COUNTRY";
export const FETCH_USERS = "FETCH_USERS";
export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";
export const FETCH_MANAGED_USERS = "FETCH_MANAGED_USERS";
export const FETCH_MANAGED_USERS_FAILURE = "FETCH_MANAGED_USERS_FAILURE";
export const FETCH_PLANNED_USERS = "FETCH_PLANNED_USERS";
export const FETCH_PLANNED_USERS_FAILURE = "FETCH_PLANNED_USERS_FAILURE";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";
export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";
export const SET_INTRODUCTION = "SET_INTRODUCTION";

export const ADD_LOCATION = "ADD_LOCATION";
export const SELECT_LOCATION = "SELECT_LOCATION";
export const DESELECT_LOCATION = "DESELECT_LOCATION";
export const ADD_LOCATION_FAILURE = "ADD_LOCATION_FAILURE";
export const EDIT_LOCATION = "EDIT_LOCATION";

export const CONTEXT = "CONTEXT";

export const SET_LOCALE = "SET_LOCALE";

export const SET_COUNTRY_ID = "SET_COUNTRY_ID";
export const SEARCH_COUNTRIES = "SEARCH_COUNTRIES";
export const ADD_COUNTRY = "ADD_COUNTRY";
export const ADD_COUNTRY_FAILURE = "ADD_COUNTRY_FAILURE";
export const SEARCH_COUNTRIES_FAILURE = "SEARCH_COUNTRIES_FAILURE";
export const FETCH_COUNTRIES = "FETCH_COUNTRIES";
export const FETCH_COUNTRIES_FAILURE = "FETCH_COUNTRIES_FAILURE";
export const FETCH_COUNTRY = "FETCH_COUNTRY";
export const SELECT_COUNTRY = "SELECT_COUNTRY";
export const DESELECT_COUNTRY = "DESELECT_COUNTRY";
export const FETCH_COUNTRY_FAILURE = "FETCH_COUNTRY_FAILURE";
export const UPDATE_COUNTRY = "UPDATE_COUNTRY";
export const UPDATE_COUNTRY_FAILURE = "UPDATE_COUNTRY_FAILURE";
export const DELETE_COUNTRY = "DELETE_COUNTRY";
export const DELETE_COUNTRY_FAILURE = "DELETE_COUNTRY_FAILURE";

export const SET_OG_ID = "SET_OG_ID";
export const SEARCH_OGS = "SEARCH_OGS";
export const ADD_OG = "ADD_OG";
export const ADD_OG_FAILURE = "ADD_OG_FAILURE";
export const SEARCH_OGS_FAILURE = "SEARCH_OGS_FAILURE";
export const FETCH_OGS = "FETCH_OGS";
export const FETCH_OGS_FAILURE = "FETCH_OGS_FAILURE";
export const FETCH_OG = "FETCH_OG";
export const SELECT_OG = "SELECT_OG";
export const DESELECT_OG = "DESELECT_OG";
export const FETCH_OG_FAILURE = "FETCH_OG_FAILURE";
export const UPDATE_OG = "UPDATE_OG";
export const UPDATE_OG_FAILURE = "UPDATE_OG_FAILURE";
export const DELETE_OG = "DELETE_OG";
export const DELETE_OG_FAILURE = "DELETE_OG_FAILURE";

// export const SET_BILLING_OU_ID = 'SET_BILLING_OU_ID'
// export const SEARCH_BILLING_OUS = 'SEARCH_BILLING_OUS'
// export const ADD_BILLING_OU = 'ADD_BILLING_OU'
// export const ADD_BILLING_OU_FAILURE = 'ADD_BILLING_OU_FAILURE'
// export const SEARCH_BILLING_OUS_FAILURE = 'SEARCH_BILLING_OUS_FAILURE'
// export const FETCH_BILLING_OUS = 'FETCH_BILLING_OUS'
// export const FETCH_BILLING_OUS_FAILURE = 'FETCH_BILLING_OUS_FAILURE'
// export const FETCH_BILLING_OU = 'FETCH_BILLING_OU'
// export const SELECT_BILLING_OU = 'SELECT_BILLING_OU'
// export const DESELECT_BILLING_OU = 'DESELECT_BILLING_OU'
// export const FETCH_BILLING_OU_FAILURE = 'FETCH_BILLING_OU_FAILURE'
// export const UPDATE_BILLING_OU = 'UPDATE_BILLING_OU'
// export const UPDATE_BILLING_OU_FAILURE = 'UPDATE_BILLING_OU_FAILURE'
// export const DELETE_BILLING_OU = 'DELETE_BILLING_OU'
// export const DELETE_BILLING_OU_FAILURE = 'DELETE_BILLING_OU_FAILURE'

export const SET_UFG_ID = "SET_UFG_ID";
export const SEARCH_UFGS = "SEARCH_UFGS";
export const ADD_UFG = "ADD_UFG";
export const ADD_UFG_FAILURE = "ADD_UFG_FAILURE";
export const SEARCH_UFGS_FAILURE = "SEARCH_UFGS_FAILURE";
export const FETCH_UFGS = "FETCH_UFGS";
export const FETCH_UFGS_FAILURE = "FETCH_UFGS_FAILURE";
export const FETCH_UFG = "FETCH_UFG";
export const SELECT_UFG = "SELECT_UFG";
export const DESELECT_UFG = "DESELECT_UFG";
export const FETCH_UFG_FAILURE = "FETCH_UFG_FAILURE";
export const UPDATE_UFG = "UPDATE_UFG";
export const UPDATE_UFG_FAILURE = "UPDATE_UFG_FAILURE";
export const DELETE_UFG = "DELETE_UFG";
export const DELETE_UFG_FAILURE = "DELETE_UFG_FAILURE";
export const ARCHIVE_UFG = "ARCHIVE_UFG";
export const ARCHIVE_UFG_FAILURE = "ARCHIVE_UFG_FAILURE";

export const SET_PROJECT_ID = "SET_PROJECT_ID";
export const SELECT_PROJECT = "SELECT_PROJECT";
export const DESELECT_PROJECT = "DESELECT_PROJECT";
export const FETCH_GLOBAL_PROJECTS = "FETCH_GLOBAL_PROJECTS";
export const FETCH_PROJECTS = "FETCH_PROJECTS";
export const FETCH_PROJECTS_FAILURE = "FETCH_PROJECTS_FAILURE";
export const FETCH_GLOBAL_PROJECTS_FAILURE = "FETCH_GLOBAL_PROJECTS_FAILURE";
export const FETCH_PROJECT = "FETCH_PROJECT";
export const FETCH_PROJECT_FAILURE = "FETCH_PROJECT_FAILURE";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const UPDATE_PROJECT_FAILURE = "UPDATE_PROJECT_FAILURE";
export const DELETE_PROJECT = "DELETE_PROJECT";
export const DELETE_PROJECT_FAILURE = "DELETE_PROJECT_FAILURE";
export const FETCH_OPPORTUNITIES = "FETCH_OPPORTUNITIES";
export const FETCH_OPPORTUNITIES_FAILURE = "FETCH_OPPORTUNITIES_FAILURE";
export const CLEAR_PROJECTS = "CLEAR_EVENTS";
export const ADD_PROJECT = "CLEAR_EVENTS";

export const SET_ACTIVITY_ID = "SET_ACTIVITY_ID";
export const SELECT_ACTIVITY = "SELECT_ACTIVITY";
export const DESELECT_ACTIVITY = "DESELECT_ACTIVITY";
export const FETCH_ACTIVITIES = "FETCH_ACTIVITIES";
export const FETCH_GLOBAL_ACTIVITIES = "FETCH_GLOBAL_ACTIVITIES";
export const FETCH_ACTIVITIES_FAILURE = "FETCH_ACTIVITIES_FAILURE";
export const FETCH_GLOBAL_ACTIVITIES_FAILURE = "FETCH_GLOBAL_ACTIVITIES_FAILURE";
export const FETCH_ACTIVITY = "FETCH_ACTIVITY";
export const FETCH_ACTIVITIES_BY_OU = "FETCH_ACTIVITIES_BY_OU";
export const FETCH_ACTIVITY_FAILURE = "FETCH_ACTIVITY_FAILURE";
export const FETCH_ACTIVITIES_FAILURE_BY_OU = "FETCH_ACTIVITIES_FAILURE_BY_OU";
export const UPDATE_ACTIVITY = "UPDATE_ACTIVITY";
export const UPDATE_ACTIVITY_FAILURE = "UPDATE_ACTIVITY_FAILURE";
export const DELETE_ACTIVITY = "DELETE_ACTIVITY";
export const DELETE_ACTIVITY_FAILURE = "DELETE_ACTIVITY_FAILURE";

export const SET_PROFESSION_ID = "SET_PROFESSION_ID";
export const SEARCH_PROFESSIONS = "SEARCH_PROFESSIONS";
export const ADD_PROFESSION = "ADD_PROFESSION";
export const ADD_PROFESSION_FAILURE = "ADD_PROFESSION_FAILURE";
export const SEARCH_PROFESSIONS_FAILURE = "SEARCH_PROFESSIONS_FAILURE";
export const FETCH_PROFESSIONS = "FETCH_PROFESSIONS";
export const FETCH_PROFESSIONS_FAILURE = "FETCH_PROFESSIONS_FAILURE";
export const FETCH_PROFESSION = "FETCH_PROFESSION";
export const SELECT_PROFESSION = "SELECT_PROFESSION";
export const DESELECT_PROFESSION = "DESELECT_PROFESSION";
export const FETCH_PROFESSION_FAILURE = "FETCH_PROFESSION_FAILURE";
export const UPDATE_PROFESSION = "UPDATE_PROFESSION";
export const UPDATE_PROFESSION_FAILURE = "UPDATE_PROFESSION_FAILURE";
export const DELETE_PROFESSION = "DELETE_PROFESSION";
export const DELETE_PROFESSION_FAILURE = "DELETE_PROFESSION_FAILURE";

export const SET_COMPANY_ID = "SET_COMPANY_ID";
export const FETCH_COMPANIES = "FETCH_COMPANIES";
export const FETCH_COMPANIES_FAILURE = "FETCH_COMPANIES_FAILURE";
export const ADD_COMPANY = "ADD_COMPANY";
export const ADD_COMPANY_FAILURE = "ADD_COMPANY_FAILURE";
export const SELECT_COMPANY = "SELECT_COMPANY";
export const DESELECT_COMPANY = "DESELECT_COMPANY";
export const SEARCH_COMPANIES = "SEARCH_COMPANIES";
export const SEARCH_COMPANIES_FAILURE = "SEARCH_COMPANIES_FAILURE";
export const FETCH_COMPANY = "FETCH_COMPANY";
export const FETCH_COMPANY_FAILURE = "FETCH_COMPANY_FAILURE";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const UPDATE_COMPANY_FAILURE = "UPDATE_COMPANY_FAILURE";
export const DELETE_COMPANY = "DELETE_COMPANY";
export const DELETE_COMPANY_FAILURE = "DELETE_COMPANY_FAILURE";

export const FETCH_BOOKINGS = "FETCH_BOOKINGS";
export const FETCH_ORG_OVERVIEW = "FETCH_ORG_OVERVIEW";
export const FETCH_ORGS_BOOKING_STATS = "FETCH_ORGS_BOOKING_STATS";
export const FETCH_ORGS_BOOKING_STATS_FAILURE = "FETCH_ORGS_BOOKING_STATS_FAILURE";
export const FETCH_ORG_OVERVIEW_FAILURE = "FETCH_ORG_OVERVIEW_FAILURE";
export const FETCH_RECENT_BOOKINGS = "FETCH_RECENT_BOOKINGS";
export const FETCH_RECENT_BOOKED_PROJECTS = "FETCH_RECENT_BOOKED_PROJECTS";
export const FETCH_RECENT_BOOKED_PROJECTS_FAILURE = "FETCH_RECENT_BOOKED_PROJECTS_FAILURE";
export const FETCH_USER_BOOKINGS = "FETCH_USER_BOOKINGS";
export const FETCH_BOOKINGS_FAILURE = "FETCH_BOOKINGS_FAILURE";
export const FETCH_USER_BOOKINGS_FAILURE = "FETCH_USER_BOOKINGS_FAILURE";
export const FETCH_RECENT_BOOKINGS_FAILURE = "FETCH_RECENT_BOOKINGS_FAILURE";
export const UPDATE_BOOKING = "UPDATE_BOOKING";
export const UPDATE_BOOKING_FAILURE = "UPDATE_BOOKING_FAILURE";
export const DELETE_BOOKING = "DELETE_BOOKING";
export const DELETE_BOOKING_FAILURE = "DELETE_BOOKING_FAILURE";
export const CLEAR_BOOKINGS = "CLEAR_BOOKINGS";
export const CLEAR_BOOKINGS_FAILURE = "CLEAR_BOOKINGS_FAILURE";
export const SET_FILTERED_PROJECTS = "SET_FILTERED_PROJECTS";
export const SET_FILTERED_ACTIVITIES = "SET_FILTERED_ACTIVITIES";
export const FETCH_ORG_MONTHLY_INDIVIDUAL_OVERVIEW = "FETCH_ORG_MONTHLY_INDIVIDUAL_OVERVIEW";
export const FETCH_ORG_USER_MONTHLY_INDIVIDUAL_OVERVIEW = "FETCH_ORG_USER_MONTHLY_INDIVIDUAL_OVERVIEW";
export const FETCH_ORGS_MONTHLY_OVERVIEW = "FETCH_ORGS_MONTHLY_OVERVIEW";
export const FETCH_ORGS_MONTHLY_OVERVIEW_FAILURE = "FETCH_ORGS_MONTHLY_OVERVIEW_FAILURE";
export const FETCH_ORG_MONTHLY_INDIVIDUAL_OVERVIEW_FAILURE = "FETCH_ORG_MONTHLY_INDIVIDUAL_FAILURE";
export const FETCH_ORG_USER_MONTHLY_INDIVIDUAL_OVERVIEW_FAILURE = "FETCH_ORG_USER_MONTHLY_INDIVIDUAL_OVERVIEW_FAILURE";

export const FETCH_HISTORY = "FETCH_HISTORY";
export const FETCH_HISTORY_FAILURE = "FETCH_HISTORY_FAILURE";
export const SELECT_HISTORY_ITEM = "SELECT_HISTORY_ITEM";
export const UNSELECT_HISTORY_ITEM = "UNSELECT_HISTORY_ITEM";
export const SET_NEEDS_HISTORY = "SET_NEEDS_HISTORY";
export const SET_LAST_SEARCH_QUERY = "SET_LAST_SEARCH_QUERY";
export const CLEAR_LAST_SEARCH_QUERY = "CLEAR_LAST_SEARCH_QUERY";
export const SET_LAST_MIN_DATE = "SET_LAST_MIN_DATE";
export const CLEAR_LAST_MIN_DATE = "CLEAR_LAST_MIN_DATE";
export const SET_LAST_MAX_DATE = "SET_LAST_MAX_DATE";
export const CLEAR_LAST_MAX_DATE = "CLEAR_LAST_MAX_DATE";

export const SET_LOCATION_ID = "SET_LOCATION_ID";
export const FETCH_LOCATIONS = "FETCH_LOCATIONS";
export const FETCH_LOCATIONS_FAILURE = "FETCH_LOCATIONS_FAILURE";
export const FETCH_LOCATION = "FETCH_LOCATION";
export const FETCH_LOCATION_FAILURE = "FETCH_LOCATION_FAILURE";
export const UPDATE_LOCATION = "UPDATE_LOCATION";
export const UPDATE_LOCATION_FAILURE = "UPDATE_LOCATION_FAILURE";
export const DELETE_LOCATION = "DELETE_LOCATION";
export const DELETE_LOCATION_FAILURE = "DELETE_LOCATION_FAILURE";
export const SEARCH_LOCATIONS = "SEARCH_LOCATIONS";
export const SEARCH_LOCATIONS_FAILURE = "SEARCH_LOCATIONS_FAILURE";

export const FETCH_MANAGED_ORGANIZATIONS = "FETCH_MANAGED_ORGANIZATIONS";
export const FETCH_MANAGED_ORGANIZATIONS_FAILURE = "FETCH_MANAGED_ORGANIZATIONS_FAILURE";
export const SET_ORGANIZATION_ID = "SET_ORGANIZATION_ID";
export const ADD_ORGANIZATION = "ADD_ORGANIZATION";
export const ADD_ORGANIZATION_FAILURE = "ADD_ORGANIZATION_FAILURE";
export const SELECT_ORGANIZATION = "SELECT_ORG";
export const DESELECT_ORGANIZATION = "DESELECT_ORG";
export const FETCH_ORGANIZATIONS = "FETCH_ORGANIZATIONS";
export const FETCH_ORGANIZATIONS_FAILURE = "FETCH_ORGANIZATIONS_FAILURE";
export const FETCH_ORGANIZATION = "FETCH_ORGANIZATION";
export const FETCH_ORGANIZATION_FAILURE = "FETCH_ORGANIZATION_FAILURE";
export const UPDATE_ORGANIZATION = "UPDATE_ORGANIZATION";
export const UPDATE_ORGANIZATION_FAILURE = "UPDATE_ORGANIZATION_FAILURE";
export const DELETE_ORGANIZATION = "DELETE_ORGANIZATION";
export const DELETE_ORGANIZATION_FAILURE = "DELETE_ORGANIZATION_FAILURE";
export const ARCHIVE_ORGANIZATION = "ARCHIVE_ORGANIZATION";
export const ARCHIVE_ORGANIZATION_FAILURE = "ARCHIVE_ORGANIZATION_FAILURE";

export const CREATE_EVENT = "CREATE_EVENT";
export const UPDATE_EVENT = "UPDATE_EVENT";
export const DELETE_EVENT = "DELETE_EVENT";
export const CLEAR_EVENTS = "CLEAR_EVENTS";
export const SET_WEEKENDS_ENABLED = "SET_WEEKENDS_ENABLED";
export const SET_HOLIDAYS_ENABLED = "SET_HOLIDAYS_ENABLED";

export const ADD_OUT_DAY = "ADD_OUT_DAY";
export const ADD_OUT_DAY_FAILURE = "ADD_OUT_DAY_FAILURE";
export const FETCH_OUT_DAYS = "FETCH_OUT_DAYS";
export const FETCH_OUT_DAYS_FAILURE = "FETCH_OUT_DAYS_FAILURE";
export const FETCH_USER_OUT_DAYS = "FETCH_USER_OUT_DAYS";
export const FETCH_USER_OUT_DAYS_FAILURE = "FETCH_USER_OUT_DAYS_FAILURE";
export const DELETE_OUT_DAY = "DELETE_OUT_DAY";
export const DELETE_OUT_DAY_FAILURE = "DELETE_OUT_DAY_FAILURE";

export const FETCH_ACTIVITY_DESCRIPTIONS = "FETCH_ACTIVITY_DESCRIPTIONS";
export const FETCH_ACTIVITY_DESCRIPTIONS_FAILURE = "FETCH_ACTIVITY_DESCRIPTIONS_FAILURE";
export const CREATE_ACTIVITY_DESCRIPTION = "CREATE_ACTIVITY_DESCRIPTION";
export const CREATE_ACTIVITY_DESCRIPTION_FAILURE = "CREATE_ACTIVITY_DESCRIPTION_FAILURE";
export const UPDATE_ACTIVITY_DESCRIPTION = "UPDATE_ACTIVITY_DESCRIPTION";
export const UPDATE_ACTIVITY_DESCRIPTION_FAILURE = "UPDATE_ACTIVITY_DESCRIPTION_FAILURE";
export const DELETE_ACTIVITY_DESCRIPTION = "DELETE_ACTIVITY_DESCRIPTION";
export const DELETE_ACTIVITY_DESCRIPTION_FAILURE = "DELETE_ACTIVITY_DESCRIPTION_FAILURE";

export const FETCH_SUGAR_KEY_USERS = "FETCH_SUGAR_KEY_USERS";
export const FETCH_SUGAR_KEY_USERS_FAILURE = "FETCH_SUGAR_KEY_USERS_FAILURE";
export const CREATE_SUGAR_KEY_USER = "CREATE_SUGAR_KEY_USER";
export const CREATE_SUGAR_KEY_USER_FAILURE = "CREATE_SUGAR_KEY_USER_FAILURE";
export const DELETE_SUGAR_KEY_USER = "DELETE_SUGAR_KEY_USER";
export const DELETE_SUGAR_KEY_USER_FAILURE = "DELETE_SUGAR_KEY_USER_FAILURE";
